// import {HeaderElement, HeaderElementType } from "src/types";

// const resourcesHeader = {
//   title: 'Resources',
//   redirectLink: '',
//   actionType: HeaderElementType.DRPODOWN,
//   dropdown: [
//     {
//       title: 'FUROSCIX PRESCRIPTION START FORM on body  ',
//       redirectLink: '/assets/request-form-2025-12.pdf',
//     },
//     {
//       title: 'Letter of Medical Necessity',
//       redirectLink: '/assets/Letter_of_Medical_Necessity.docx',
//     },{
//       title: 'Appeal Template',
//       redirectLink: '/assets/FUROSCIX_Appeal_Document.docx',
//     },{
//       title: 'NDC Block Appeal Template',
//       redirectLink: '/assets/FUROSCIX_Appeal_Template_NDC_Block.docx',
//     },
//   ]
// };

// const resourceVideosHeader = {
//   title: <><span className="d-lg-none d-xl-inline-block">Helpful</span> Videos</>,
//   redirectLink: '',
//   actionType: HeaderElementType.DRPODOWN,
//   dropdown: [
//     {
//       title: 'How to Complete an Expedited Request',
//       redirectLink: '/videos/direct_expedited',
//       actionType: HeaderElementType.ROUTE,
//     },
//     {
//       title: 'How to Complete a Coverage & Copay Determination Request',
//       redirectLink: '/videos/direct-coverage_co-pay',
//       actionType: HeaderElementType.ROUTE,
//     },
//   ]
// }

// export const LOGGED_IN_VIDEO_NAMES = ["direct_expedited", "direct-coverage_co-pay"]
// const subMenuReports : HeaderElement = {
//   title: 'Reports',
//   redirectLink: '',
//   actionType: HeaderElementType.DRPODOWN,
//   dropdown: [
//   ],
// }
// const publicResourcesHeader = {
//   title: 'Resources',
//   redirectLink: '',
//   actionType: HeaderElementType.DRPODOWN,
//   dropdown: [
//    {
//       title: 'Letter of Medical Necessity',
//       redirectLink: '/assets/Letter_of_Medical_Necessity.docx',
//     },{
//       title: 'Appeal Template',
//       redirectLink: '/assets/FUROSCIX_Appeal_Document.docx',
//     },{
//       title: 'NDC Block Appeal Template',
//       redirectLink: '/assets/FUROSCIX_Appeal_Template_NDC_Block.docx',
//     },
//   ]
// };

// const publicResourcesVideosHeader = {
//   title: 'Helpful Videos',
//   redirectLink: '',
//   actionType: HeaderElementType.DRPODOWN,
//   dropdown: [
//     {
//       title: 'Enrollment Tutorial',
//       redirectLink: '/videos/enrollment_tutorial',
//       actionType: HeaderElementType.ROUTE,
//     },
//   ]
// };

// export const PublicHeader: HeaderElement[] = [
//   {
//     title: 'Welcome',
//     redirectLink: '/users/sign_in',
//     actionType: HeaderElementType.ROUTE,
//   },
//   {
//     title: 'Enrollment',
//     redirectLink: '/enrollments/new',
//     actionType: HeaderElementType.ROUTE,
//   },
//   {
//     title: 'Upload Prescription Start Form',
//     redirectLink: '/faxes_ins/new',
//     actionType: HeaderElementType.BUTTON,
//   },
//   publicResourcesHeader,
//   publicResourcesVideosHeader,
// ];

// export const AuthenticatedManufactureHeader: HeaderElement[] = [
//   {
//     title: 'National',
//     redirectLink: '/statistics',
//     actionType: HeaderElementType.ROUTE,
//   },
//   {} as unknown as HeaderElement,
//   {
//     title: 'Action Dashboard',
//     redirectLink: '/todos_statistics',
//     actionType: HeaderElementType.ROUTE,
//   },
  
//   {
//     ...resourcesHeader,
//     dropdown: [
//       ...resourcesHeader.dropdown,
//       {
//         title: 'Data Dictionary Document',
//         redirectLink: '/assets/Status_and_Sub_Status_Data_Dictionary 5.22.xlsx',
//       },
//       {
//         title: 'Denial Definition Document',
//         redirectLink: '/assets/Denial_Reasons.pdf',
//       },
//     ]
//   },{...subMenuReports},
// ];
// export const AuthenticatedHCPHeader: HeaderElement[] = [
  
//   {
//     title: 'Cases',
//     redirectLink: '/cases',
//     actionType: HeaderElementType.ROUTE,
//   },
//   {
//     title: 'Prescription Start Form',
//     redirectLink: '/cases/new',
//     actionType: HeaderElementType.ROUTE,
//   },
//   {
//     ...resourcesHeader,
//     dropdown: [
//       {
//         title: 'FUROSCIX PRESCRIPTION START FORM ReadyFlow autoinjector ',
//         redirectLink: '/assets/FSX Prescription start form_updated with ReadyFlow 5.21.pdf',
//       },
//       resourcesHeader.dropdown[0],
//       ...resourcesHeader.dropdown.slice(1),
//     ]
//   },
//   resourceVideosHeader,
// ];


import {HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
        title: 'Prescription Start Form – ReadyFlow Autoinjector',
        redirectLink: '/assets/FSX Prescription start form_updated with ReadyFlow 5.21.pdf',
    },
    {
      title: 'Prescription Start Form – On-body  ',
      redirectLink: '/assets/request-form-2025-12.pdf',
    },
    {
      title: 'Letter of Medical Necessity',
      redirectLink: '/assets/Letter_of_Medical_Necessity.docx',
    },{
      title: 'Appeal Letter',
      redirectLink: '/assets/FUROSCIX_Appeal_Document.docx',
    },{
      title: 'Appeal Letter, NDC Block',
      redirectLink: '/assets/FUROSCIX_Appeal_Template_NDC_Block.docx',
    },
  ]
};

const resourceVideosHeader = {
  title: <><span className="d-lg-none d-xl-inline-block">Helpful</span> Videos</>,
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'How to Complete an Expedited Request',
      redirectLink: '/videos/direct_expedited',
      actionType: HeaderElementType.ROUTE,
    },
    {
      title: 'How to Complete a Coverage & Copay Determination Request',
      redirectLink: '/videos/direct-coverage_co-pay',
      actionType: HeaderElementType.ROUTE,
    },
  ]
}

export const LOGGED_IN_VIDEO_NAMES = ["direct_expedited", "direct-coverage_co-pay"]
const subMenuReports : HeaderElement = {
  title: 'Reports',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
  ],
}
const publicResourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
   {
      title: 'Letter of Medical Necessity',
      redirectLink: '/assets/Letter_of_Medical_Necessity.docx',
    },{
      title: 'Appeal Template',
      redirectLink: '/assets/FUROSCIX_Appeal_Document.docx',
    },{
      title: 'NDC Block Appeal Template',
      redirectLink: '/assets/FUROSCIX_Appeal_Template_NDC_Block.docx',
    },
  ]
};

const publicResourcesVideosHeader = {
  title: 'Helpful Videos',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Enrollment Tutorial',
      redirectLink: '/videos/enrollment_tutorial',
      actionType: HeaderElementType.ROUTE,
    },
  ]
};

export const PublicHeader: HeaderElement[] = [
  {
    title: 'Welcome',
    redirectLink: '/users/sign_in',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Enrollment',
    redirectLink: '/enrollments/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Upload Prescription Start Form',
    redirectLink: '/faxes_ins/new',
    actionType: HeaderElementType.BUTTON,
  },
  publicResourcesHeader,
  publicResourcesVideosHeader,
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  {
    title: 'National',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {} as unknown as HeaderElement,
  {
    title: 'Action Dashboard',
    redirectLink: '/todos_statistics',
    actionType: HeaderElementType.ROUTE,
  },
  
  {
    ...resourcesHeader,
    dropdown: [
      ...resourcesHeader.dropdown,
      {
        title: 'Data Dictionary Document',
        redirectLink: '/assets/Status_and_Sub_Status_Data_Dictionary 5.22.xlsx',
      },
      {
        title: 'Denial Definition Document',
        redirectLink: '/assets/Denial_Reasons.pdf',
      },
    ]
  },{...subMenuReports},
];
export const AuthenticatedHCPHeader: HeaderElement[] = [
  
  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Prescription Start Form',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    ...resourcesHeader,
   
  },
  resourceVideosHeader,
];


 